import {EventEmitter, Injectable} from "@angular/core";
import {IPlatformToolHandler} from "@shared/components/platform-tool/platform-tool-container/platform-tool-component";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {MagicLinkModel, TabModel} from "@shared/models/platform-tool-models";
import {PlatformCommand} from "@shared/commands/command-base";
import {Router} from "@angular/router";
import {DialogModel} from "@shared/models/dialog.model";
import {DialogService} from "@shared/services/dialog-service";
import {take, takeUntil} from 'rxjs/operators';
import {CommandService} from "@core/services/command.service";
import {AddReportCommand} from "@features/data-survey/commands/report.commands";
import {FuseSplashScreenService} from "@barebone-fuse/@fuse/services/splash-screen.service";
import {ParticleCacheService} from "@core/services/particle-cache.service";
import {Dynamic_Grid_Data_Request_Parameters} from "@shared/store/actions/virtual-grid.actions";
import {ArchiveReportCommand} from "@features/data-survey/commands/survey.commands";
import {Subject} from "rxjs";
import {Configuration} from "@shared/models/configuration";
import {SetActivityFeedAction, SetCurrentHelpNoteAction} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";
import {Store} from "@ngrx/store";
import { PlatformSidebarService } from '@shared/components/platform-sidebar/store/platform-sidebar.service';

@Injectable({
  providedIn: 'root'
})
export class PlatformToolDataSurveyReportContentHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  sourceKey: string;
  showArchived: boolean;
  selectedTab: any;
  ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private sideBarService: PlatformSidebarService,
    private dialogService: DialogService,
    private commandService: CommandService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private platformSidebarStore: Store<PlatformSidebarState>,
  ) {
    this.invalidateSubject = new InvalidateSubject();
    this.sourceKey = 'Generic-Report';
    this.showArchived = false;
  }

  executeCommand(command: PlatformCommand) {
    if (command.fieldValues['RedirectUrl']) {
      this.router.navigateByUrl(command.fieldValues['RedirectUrl']);
    } else {
      switch (command.name) {
        case 'AddReportCommand':
          this.addReport();
          break;
        case 'ShowArchivedCommand':
          this.showArchivedChanged(command);
          break;
      }
    }
  }

  valueChanged($event) {
    console.log($event);
    if ($event.action) {
      switch ($event.action.id) {
        case 'AddTask':
          this.router.navigateByUrl(`dac6-reporter/reports/${$event.item.id}/add-task`);
          return;
        case 'ArchiveReport':
          const archiveCommand = new ArchiveReportCommand($event.item.id, true);
          this.commandService.executeCommand(archiveCommand).pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
            this.invalidateSubject.invalidate();
          });
          break;
        case 'UnarchiveReport':
          const unarchiveCommand = new ArchiveReportCommand($event.item.id, false);
          this.commandService.executeCommand(unarchiveCommand).pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
            this.invalidateSubject.invalidate();
          });
          break;
      }
    }
    if ($event.fieldDefinition && $event.fieldDefinition.key === 'Title' ) {
      this.router.navigateByUrl(`dac6-reporter/reports/${$event.item.id}`);
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTab = selectedTab;
    if(this.magicLinkModel.fieldValues["SourceType"]) this.sourceKey = this.magicLinkModel.fieldValues["SourceType"];
    this.showArchived = false;
    const config = Configuration.getSmartGridConfig(this.sourceKey);
    config.Parameters['SHOW_ARCHIVED'] = this.showArchived;
    // const activityInfo = {type: 'Tool', 'id': 'generic-report', 'title': 'Reports', isDefault: true};
    // this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));
    this.showHelpNoteSidebarIcon()
  }

  showHelpNoteSidebarIcon() {
    this.sideBarService.showSidebarIcon('Details');
    let helpNoteId = 'dac6-reports';
    const helpNoteObj = this.getHelpNoteObject(helpNoteId);
    this.platformSidebarStore.dispatch(new SetCurrentHelpNoteAction(helpNoteObj));
  }

  private getHelpNoteObject(helpNoteId) {
    let helpNoteObj = {};
    helpNoteObj['helpNoteId'] = helpNoteId;
    return helpNoteObj;
  }

  destroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  addReport() {
    const dialogModel = DialogModel.create('Add Report', 'AddReportComponent',
      {title: '', description: ''}
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(state => {
      if (state.action === 'OK') {
        this.commandService.executeCommand(new AddReportCommand(state.data.input.title, state.data.input.description))
          .pipe(take(1)).subscribe(commandState => {
          console.log('AddReportCommand', commandState);
          this.router.navigateByUrl(`dac6-reporter/reports/${commandState.Payload.Id}/add-task`);
        });
      }
    });
  }
  private showArchivedChanged(command: PlatformCommand) {
    this.fuseSplashScreenService.show();
    console.log('showArchivedChanged');
    this.showArchived = command.isChecked;
    this.selectedTab.tabData['SHOW_ARCHIVED'] = command.isChecked;
    const config = Configuration.getSmartGridConfig(this.sourceKey);
    config.Parameters['SHOW_ARCHIVED'] = this.showArchived;
    this.invalidateSubject.invalidate();
    this.fuseSplashScreenService.hide();
  }

}
